import { createContext, Dispatch, SetStateAction, useState } from 'react'
import { useStorage } from '../../../common/hooks/useStorage'
import { LocalStorageKey } from '../../../common/enums/LocalStorageKey'

interface WebcamTestContextValue {
  testEnabled: boolean
  setTestEnabled: Dispatch<SetStateAction<boolean>>
  autostart: boolean
  setAutostart: Dispatch<SetStateAction<boolean>>
}

export const WebcamTestContext = createContext({} as WebcamTestContextValue)

export function useWebcamTestContextValue(): WebcamTestContextValue {
  const [autostart, setAutostart] = useStorage<boolean>(LocalStorageKey.TestAutostart, false)
  const [testEnabled, setTestEnabled] = useState<boolean>(autostart)

  return { autostart, setAutostart, testEnabled, setTestEnabled }
}
